export enum Languages {
  EN_US = 'en',
  ITA = 'it',
  ESP = 'es',
}
export const DEFAULT_LANGUAGE: string = Languages.ITA;
